import CloseIcon from '@mui/icons-material/Close';
import propTypes from 'prop-types';
import classes from './SingleHeader.module.css';

// 顶部简易导航栏，closeIcon + 标题
export default function SingleHeader({ title, handleClose }) {
  return (
    <div>
      <div className={classes.header_wrapper}>
        <div className={classes.header}>
          <span>
            {title}
          </span>
          <span className={classes.close_icon} onClick={handleClose}>
            <CloseIcon />
          </span>
        </div>
      </div>
      <div className={classes.empty}></div>
    </div>
  );
}

SingleHeader.propTypes = {
  title: propTypes.string.isRequired,
  handleClose: propTypes.func.isRequired,
};
